import type { Delivery } from "@types_def/models/delivery.types";

import { useFindDeliveryByIdQuery } from "@/libs/generated/hooks";

function useDeliveryCodes(publicId: string) {
  return useFindDeliveryByIdQuery(
    { GetByIdInput: { id: Number(publicId) } },
    {
      enabled: Number.isFinite(Number(publicId)),
      select: ({ findDeliveryById }) =>
        findDeliveryById as Pick<Delivery, "startCode" | "destinationCode">,
    }
  );
}

export default useDeliveryCodes;
